/**
 * 按钮Mixin（处理返回按钮逻辑）
*/
export default {
  // 生命周期钩子
  mounted () {
    // 初始化返回按钮
    this.initBackButtons()
  },
  methods: {
  // 检查是否存在路由历史记录
    hasHistory () {
    // 检查路由历史记录长度
      return window.history.length > 1
    },
  // 检查元素是否为返回按钮且事件会执行 $router.go(-1)
    isGoBackButton (el) {
      if (!el) return false

    // 检查是否为按钮元素
      if (!el.tagName || el.tagName.toLowerCase() !== 'button') return false

    // 检查按钮文本是否包含返回按钮的文本
      const buttonText = el.textContent || el.innerText || ''

      // 安全地调用 $t
      const getTranslation = () => {
        try {
          return this.$t && typeof this.$t === 'function'
            ? this.$t('lable.goBack')
            : null // 默认值
        } catch (e) {
          return null // 默认值
        }
      }

      const goBackText = getTranslation()
      const isCheckBackHistory = el.className.includes('check-back-history')
      if (isCheckBackHistory && goBackText && buttonText.includes(goBackText)) {
        return true
      }

      return false
    },
  // 初始化返回按钮，检查是否有历史记录，无则隐藏
    initBackButtons () {
    // 确保在 DOM 渲染完成后执行
      this.$nextTick(() => {
      // 检查是否存在路由历史记录
        const hasHistory = this.hasHistory()

      // 如果有历史记录，不需要隐藏按钮
        if (hasHistory) return

      // 查找页面中的所有按钮元素
        const buttons = document.querySelectorAll('button')
        buttons.forEach(button => {
        // 检查是否为返回按钮
          if (this.isGoBackButton(button)) {
          // 隐藏返回按钮
            button.style.display = 'none'
          }
        })

      // 查找可能包含返回按钮的其他元素（如 el-button 组件）
        // const elButtons = document.querySelectorAll('.el-button')
        // elButtons.forEach(button => {
        // // 检查是否为返回按钮
        //   if (this.isGoBackButton(button)) {
        //   // 隐藏返回按钮
        //     button.style.display = 'none'
        //   }
        // })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/button.js